<template>
    <div data-cy="cy-ps-box" class="pf4-box" :class="{ 'pf4-box--with-arrow': !boxIsRedirect, 'pf4-box--selected': data.isSelected, 'cy-ps-box--selected': data.isSelected, 'pf4-box__flex': onlyHeader }">
        <div v-if="data.bannerText" class="banner">
            <span class="banner__text">{{ $t(data.bannerText) }}</span>
        </div>
        <div v-if="data.alertText" class="alert-banner">{{ $t(data.alertText) }}</div>
        <img v-if="data.image" :src="`${publicPath}img/${data.image}`">
        <h3 v-if="data.heading" :class="{ 'center-header': onlyHeader }">{{ $t(data.heading) }}</h3>
        <p v-if="data.text">{{ $t(data.text) }}</p>
        <p v-if="data.subtext" class="subtext">{{ $t(data.subtext) }}</p>

        <template v-if="data.toolType == 'Motioneering'">
            <div class="linear-motioneering-logo-spacer"></div>
            <div class="linear-motioneering-logo">{{ $t("linear-motioneering") }}</div>
        </template>

        <a v-if="data.modalRef" @click.stop="modalRefClick()" class="modal-link" href="#!">{{ $t(data.modalRef) }}</a>

        <template v-else-if="data.modal">
            <a @click.stop="$refs[`modal_${data.modal.title}`].open()" class="modal-link" href="#!">{{ $t(data.modal.title) }}</a>
            
            <div @click.prevent.stop>
                <sweet-modal overlay-theme="dark" class="blue-header" :ref="`modal_${data.modal.title}`" :title="$t(data.modal.title)">
                    {{ $t(data.modal.helpText) }}
                </sweet-modal>
            </div>
        </template>

    </div>  
</template>

<script>
export default {
    name: "PreselectionBox",
    props: {
        data: {
            bannerText: String,
            heading: String,
            text: String,
            subtext: String,
            image: String,
            toolType: String,
            modalRef: String,
            modal: Object,
            redirectUrl: String,
            isSelected: Boolean,
        },
    },
    data() {
        return {
            publicPath: process.env.BASE_URL
        }
    },
    computed: {
        onlyHeader() { return !this.data.image && !this.data.text },
        boxIsRedirect() { return this.data.redirectUrl },
    },
    methods: {

        modalRefClick() {
            this.$emit("modalRefClicked", "modal_" + this.data.modalRef);
        },

    }
}
</script>

<style scoped lang="scss">
.thomson-app {
    .pf4-box {
        border: 1px solid #d3d3d3;
        /*padding: 15px; */
        padding-top: 10px;
        margin: 10px;
        background-color: white;
        cursor: pointer;
        position: relative;
        min-height: 130px;
        padding: 1px;
    }
    @media (min-width: 768px) {
        .pf4-box {
            display: flex;
            flex-direction: column;
            flex-grow: 0;
            flex-shrink: 1;
            flex-basis: 170px;
        }
    }
    @media (min-width: 1200px) {
        .pf4-box {
            flex-basis: 206px
        }
    }
    .pf4-box__flex {
        display: flex;
    }
    .pf4-box--selected {
        border: 2px solid #1f427d;
        padding: 0;
    }

    .pf4-preselection .pf4-box .banner {
        display: flex;
        flex-direction: column;
        margin: -1px -1px 0;
        background-color: #0099ff;
        height: 41px;
    }
    .pf4-preselection .pf4-box.pf4-box--selected .banner {
        margin: 0;
        height: 40px;
    }
    .pf4-preselection .pf4-box .banner .banner__text {
        margin: auto;
        font-size: 13px;
        font-weight: 700;
        color: #FFFFFF;
        text-transform: uppercase;
        text-align: center;
    }
    .pf4-preselection .pf4-box h3 {
        color: #666766;
        font-size: 16px;
        margin: 20px 15px 15px 15px;
        text-align: left;
    }
    .pf4-preselection .pf4-box h3.center-header {
        margin: auto;
        text-align: center;
    }
    .pf4-preselection .pf4-box p {
        margin: 0px 15px 15px 15px;
        color: #666766;
        font-size: 14px;
        clear: none;
    }
    .pf4-preselection .pf4-box a.modal-link {
        display: block;
        margin: auto 10px 10px 10px;
        font-size: 12px;
        text-align: end;
        clear: none;
    }
    .pf4-preselection .pf4-box img {
        max-width: 100%;
        height: auto;
        min-height: 1px;
        margin: 0 auto;
        display: block;
        flex-shrink: 0;
        align-self: flex-start;
    }

    .pf4-preselection .pf4-box .subtext {
        text-align: center;
        margin-bottom: 10px;
        margin-top: auto;
        font-size: 12px;
        color: #09f;
    }

    .pf4-box--with-arrow.pf4-box--selected:after,
    .pf4-box--with-arrow.pf4-box--selected:before {
        top: 100%;
        left: 50%;
        border: solid transparent;
        content: " ";
        height: 0;
        width: 0;
        position: absolute;
        pointer-events: none;
    }

    .pf4-box--with-arrow.pf4-box--selected:after {
        border-color: rgba(255,255,255,0);
        border-top-color: white;
        border-width: 20px;
        margin-left: -20px;
    }

    .pf4-box--with-arrow.pf4-box--selected:before {
        border-color: rgba(194,225,245,0);
        border-top-color: #1f427d;
        border-width: 23px;
        margin-left: -23px;
    }

    @media (max-width: 767px) {
        .pf4-preselection .pf4-box .banner {
            height: 31px;
        }
        .pf4-preselection .pf4-box.pf4-box--selected .banner {
            height: 30px;
        }
        .pf4-box--selected {
            margin-bottom: 25px;
        }
        .pf4-preselection .pf4-box img {
            float: left;
            margin-left: 5px;
            margin-right: 5px;
            height: 70px;
        }
        .pf4-box {
            min-height: 110px;
        }
        .pf4-preselection .pf4-box h3 {
            margin-top: 5px;
            margin-bottom: 5px;
        }
        .pf4-box__flex {
            flex-direction: column;
        }
    }

    .linear-motioneering-logo {
        margin: auto auto 10px;
        padding: 4px 8px;
        line-height: 18px;
        background-color: #199ed8;
        border-radius: 6px;
        font-weight: 700;
        font-style: normal;
        font-size: 16px;
        color: #FFFFFF;
        text-align: left;
    }
    @media (max-width: 1199px) {
        .linear-motioneering-logo {
            font-size: 12px;
            padding: 2px 4px;
        }
    }
    @media (max-width: 767px) {
        .linear-motioneering-logo {
            margin: auto;
            display: inline-block;
        }
    }
    @media (min-width: 768px) {
        .linear-motioneering-logo-spacer {
            margin-top: -10px;
        }
    }

    .sweet-modal-overlay {
        cursor: default;
    }

    
    .alert-banner {
        background-color: #0099FF;
        color: white;
        text-align: center;
        text-transform: uppercase;
        font-weight: bold;
        font-size: 9px;
    }
    @media (max-width: 767px) {
        .alert-banner {
            margin: -1px -1px 0;
        }
    }
    @media (min-width: 768px) {
        .alert-banner {
            position: absolute;
            top: 0px;
            left: 0px;
            right: 0px;
        }
    }
    .pf4-box--selected .alert-banner {
        top: 0px;
        left: 0px;
        right: 0px;
        margin: 0;
    }
}
</style>